/* Display translation contract shared by homepage, product chat and download chat. */
(function (root) {
  'use strict';
  var selectedLanguage = null;
  ['homepage:language-change', 'dialog:language-change', 'universe-bean-language-change'].forEach(function (type) {
    root.addEventListener(type, function (event) {
      var detail = event.detail || {};
      var value = detail.lang || detail.language || detail.code;
      if (value) selectedLanguage = normalize(value);
    });
  });
  function normalize(value) {
    if (value === 'nan-TW') return 'zh-TW';
    if (value === 'nan-TW') return 'zh-TW';
    return ['sichuan', 'shanghai', 'henan', 'cn', 'zh-CN'].includes(value) ? 'zh' : (value || 'zh');
  }
  function current() {
    if (selectedLanguage) return selectedLanguage;
    var language = root.AppCenterLanguage && root.AppCenterLanguage.current;
    if (!language && root.OpeningCopy) language = root.OpeningCopy.getLanguage();
    if (!language && root.HomepageLanguage) language = root.HomepageLanguage.getLanguage();
    if (!language) {
      try { language = root.localStorage.getItem('universe-power-language'); } catch (_) {}
    }
    return normalize(language);
  }
  function read(payload, requested) {
    if (payload && Number(payload.code) >= 400) throw new Error(payload.msg || '服务请求失败');
    var data = payload && payload.data || payload || {};
    var state = data.translation && data.translation.status;
    var language = normalize(data.language);
    if (state === 'translated') {
      if (language !== requested) throw new Error('返回语种与请求不一致，请重试');
      return {status:state, language:language, message:''};
    }
    if (requested === 'zh' && (!state || state === 'skipped')) {
      return {status:'skipped', language:'zh', message:''};
    }
    return {status:'failed', language:'zh', message:'翻译暂时不可用，已保留原文。'};
  }
  function render(target, translation) {
    if (!target || !translation) return;
    target.dataset.apiContent = '';
    target.dataset.languageStatic = '';
    target.dataset.translationStatus = translation.status;
    target.lang = translation.language === 'zh' ? 'zh-CN' : translation.language;
    target.dir = ['ar', 'ur'].includes(translation.language) ? 'rtl' : 'ltr';
    if (translation.message) {
      var notice = target.ownerDocument.createElement('p');
      notice.className = 'bean-chat-api-status is-error';
      notice.setAttribute('role', 'status');
      var language = current();
      notice.textContent = root.HomepageLocales ? root.HomepageLocales.translate(translation.message, language) : translation.message;
      notice.lang = language === 'zh' ? 'zh-CN' : language;
      notice.dir = ['ar', 'ur'].includes(language) ? 'rtl' : 'ltr';
      target.appendChild(notice);
    }
  }
  root.BeanApiTranslation = {current:current, normalize:normalize, read:read, render:render};
})(window);



//////////////////
// WEBPACK FOOTER
// ./homepage-source/bean-api-translation.js
// module id = lI6c
// module chunks = 1